import { connect } from 'react-redux';
import { openLoginModal } from 'src/containers/LoginPage/Modal/actions';
import AuthFailed from './AuthFailed';

export default connect(
  () => ({}),
  { openLoginModal },
)(AuthFailed);
